import { useEffect } from 'react';
import {
  // 时间筛选器
  RANGE_TIME as FILTER_RANGE_TIME,
  // 级联国家筛选器
  REGION as FILTER_REGION,
} from '@/pages/intelligence/components/Filter/FilterBase/_config';
import { getIsSteamTopSellers } from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/StoreRank/utils';

import type { IRegion } from '@/pages/intelligence/types/common';
import type { IStoreRankDetailsFilter } from '@/pages/intelligence/pages/TopCharts/PCGames/components/GamesDetails/StoreRank/types';

export default function useUpdateFiltersCfg(props: {
  regionOptions: IRegion[] | null;
  getRadioOptionsTips?: Function;
  filter: IStoreRankDetailsFilter;
  inputList: any[];
  setInputList: React.Dispatch<React.SetStateAction<any[]>>;
  sinceReleaseTime?: string;
  earliestDataTime?: string;
}) {
  const { regionOptions, getRadioOptionsTips, filter, inputList, setInputList,
    sinceReleaseTime,
    earliestDataTime,
  } = props ?? {};

  // 更新 日期筛选器配置
  const upateRangeTimeCfg = (
    inputList: any[],
    cfg: {
      isSteamTopSellers: boolean;
    },
    sinceReleaseTime?: string,
    earliestDataTime?: string,
  ) => {
    const { isSteamTopSellers } = cfg ?? {};
    const filterRangeTime = inputList?.find((item) => item?.key === FILTER_RANGE_TIME);
    if (!filterRangeTime) return;
    const typeListTmp = isSteamTopSellers ? ['date', 'week'] : ['date'];
    filterRangeTime.showSelectType = typeListTmp?.length > 1;
    filterRangeTime.typeList = typeListTmp;
    filterRangeTime.sinceReleaseTime = sinceReleaseTime || '';
    filterRangeTime.earliestDataTime = earliestDataTime || '';
  };

  // 更新 级联国家筛选器控件配置
  const updateFilterRegionCfg = (
    inputList: any[],
    cfg: {
      isSteamTopSellers: boolean;
      options?: IRegion[] | null;
      getRadioOptionsTips?: Function;
    },
  ) => {
    const { isSteamTopSellers, options, getRadioOptionsTips } = cfg ?? {};
    const filterRegion = inputList?.find((item) => item?.key === FILTER_REGION);
    if (!filterRegion) return;
    // 1 展示、2 不展示
    const visibleTmp = isSteamTopSellers ? 1 : 2;
    const optionsTmp = options ?? filterRegion.options ?? [];
    filterRegion.visible = visibleTmp;
    filterRegion.options = Array.isArray(optionsTmp) ? optionsTmp : [];
    filterRegion.getRadioOptionsTips = getRadioOptionsTips;
  };

  useEffect(() => {
    const inputListTmp = [...inputList];
    const isSteamTopSellers = getIsSteamTopSellers({ platform: filter?.platform, top: filter?.top });
    // 更新 日期筛选器配置
    upateRangeTimeCfg(inputListTmp, { isSteamTopSellers },
      sinceReleaseTime,
      earliestDataTime,
    );
    // 更新国家筛选器选项数据
    updateFilterRegionCfg(inputListTmp, {
      isSteamTopSellers,
      options: regionOptions,
      getRadioOptionsTips,
    });
    setInputList(inputListTmp);
  }, [regionOptions, getRadioOptionsTips, filter?.platform, filter?.top,
    sinceReleaseTime,
    earliestDataTime,
  ]);
}
